export const baseRoutes = {
  userBaseRoutes: "/",
  adminBaseRoutes: "/admin",
  superBaseRoutes: "/super-admin",
  foundBaseRoutes: "/",
  userlandingBaseRoutes: "/",
  vendorlandingBaseRoutes: "/vendor-landing",
};
